import './style/addKeywords.scss';

import React, {useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {BolmateInput, BolmateDialog} from '../../controls';

interface Props {
    active: boolean;
    onClose: VoidFunction;
    keyword: string;
    onChangeKeyword: (value: string) => void;
    onSubmit: VoidFunction;
    loading: boolean;
    onBulkImport: VoidFunction;
}

export default function AddKeywords(props: Props) {
    const {t} = useTranslation();
    const {active, onClose, keyword, onChangeKeyword, onSubmit, loading, onBulkImport} = props;

    const canSubmit = useMemo(() => !!keyword.trim(), [keyword]);

    return (
        <BolmateDialog
            active={active}
            onClose={onClose}
            title={t('searchRankings.addKeywords.title', 'Keyword toevoegen')}
            onConfirm={onSubmit}
            confirmLabel={
                loading
                    ? t('searchRankings.addKeywords.busy', 'Bezig...')
                    : t('searchRankings.addKeywords.add', 'Toevoegen')
            }
            confirmDisabled={!canSubmit || loading}
            width='28rem'
            className='add-keywords-popup'
        >
            <div className='add-keywords-content'>
                <div className='keyword-input-section'>
                    <label className='input-label'>{t('searchRankings.addKeywords.keyword', 'Keyword')}</label>
                    <BolmateInput
                        id='add-keyword-single'
                        value={keyword}
                        onChange={onChangeKeyword}
                        placeholder={t('searchRankings.addKeywords.placeholder', 'Voer een zoekwoord in')}
                        fullWidth
                    />
                </div>
                <span className='bulk-import-hint'>
                    {t('searchRankings.addKeywords.bulkHint', 'In bulk toevoegen?')}{' '}
                    <a onClick={onBulkImport}>{t('searchRankings.addKeywords.clickHere', 'Klik hier')}</a>
                </span>
            </div>
        </BolmateDialog>
    );
}
